import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import imageCompression from 'browser-image-compression';
import ImageZoom from 'react-medium-image-zoom';
import {
  uploadCredential,
  deleteCredentialFile,
} from '../../../../actions/licensesAction';

const PlusIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
  >
    <path d="M11.6869 22.0001H10.3975C10.3281 21.9867 10.2592 21.9711 10.1893 21.9609C9.71569 21.892 9.23513 21.8543 8.76909 21.751C5.90938 21.1172 3.63786 19.5849 1.96637 17.189C0.43373 14.9921 -0.203437 12.5381 0.0564883 9.87267C0.270133 7.67746 1.09404 5.71522 2.51636 4.029C4.61836 1.53571 7.31233 0.180919 10.5719 0.0152026C12.7428 -0.0956341 14.7829 0.41443 16.6395 1.54916C19.4739 3.28166 21.2121 5.79054 21.8278 9.06238C21.9053 9.47506 21.9435 9.8958 21.9994 10.3128V11.6019C21.9817 11.7569 21.9634 11.9124 21.9462 12.0673C21.7508 13.8547 21.1858 15.5151 20.1832 17.0098C18.4315 19.6204 16.0185 21.2517 12.9155 21.8296C12.5092 21.9054 12.0965 21.9447 11.6869 22.0007V22.0001ZM9.75336 9.66768H9.52358C8.66416 9.66768 7.80527 9.66768 6.94585 9.66768C6.35174 9.66768 5.75708 9.65745 5.16297 9.6709C4.23789 9.69243 3.64378 10.5554 3.95429 11.4115C4.14049 11.9248 4.62374 12.2444 5.23347 12.2454C6.65848 12.2481 8.08349 12.246 9.50797 12.2465H9.75283C9.75283 12.3482 9.75283 12.4257 9.75283 12.5032C9.75283 13.47 9.75283 14.4363 9.75283 15.4032C9.75283 15.8831 9.7426 16.3631 9.75605 16.8425C9.78081 17.7582 10.6289 18.3468 11.4814 18.0498C12.0071 17.8669 12.33 17.3827 12.3311 16.7612C12.3332 15.3365 12.3316 13.9112 12.3316 12.4865V12.2465H12.5937C13.9471 12.2465 15.3006 12.2465 16.6535 12.2465C16.7536 12.2465 16.8542 12.2481 16.9538 12.2374C17.8094 12.1491 18.3325 11.3222 18.0473 10.5135C17.8649 9.99696 17.3816 9.6709 16.7762 9.66929C15.3727 9.66606 13.9692 9.66821 12.5657 9.66821C12.4904 9.66821 12.4156 9.66821 12.3316 9.66821C12.3316 9.31364 12.3316 8.99189 12.3316 8.67015C12.3316 7.51712 12.337 6.36464 12.33 5.21161C12.3241 4.25497 11.4684 3.64053 10.5934 3.95367C10.0784 4.13768 9.75552 4.62138 9.75444 5.22883C9.75175 6.69661 9.75336 8.16439 9.75336 9.66768Z" fill="#989FA4" />
  </svg>
);

const DeleteIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
  >
    <g clipPath="url(#clip0_61_903)">
      <path d="M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z" fill="#989FA4" />
      <path d="M6.19888 7.54579C5.67406 7.50591 5.30107 7.27443 5.09902 6.8181C4.76014 6.05164 5.33256 5.18698 6.18538 5.17922C7.17915 5.17036 8.17255 5.17479 9.16632 5.17922C9.27128 5.17959 9.31702 5.15006 9.36162 5.05591C9.68588 4.37178 10.2403 4 11.002 4C11.7581 4 12.3081 4.36883 12.638 5.04446C12.6582 5.08581 12.6762 5.12827 12.6983 5.17664C12.9094 5.17664 13.1197 5.17664 13.3303 5.17664C14.1599 5.17664 14.9895 5.17331 15.8191 5.17848C16.3176 5.18181 16.7574 5.49636 16.9279 5.95565C17.0981 6.41308 16.9605 6.92886 16.5823 7.25264C16.3881 7.41878 16.2071 7.4893 15.803 7.54985C15.803 7.60375 15.803 7.66172 15.803 7.71968C15.803 10.3702 15.8033 13.0206 15.803 15.6708C15.803 16.284 15.4723 16.7643 14.9216 16.9316C14.7721 16.977 14.609 16.9965 14.4519 16.9969C12.1506 17.001 9.84933 17.0002 7.54765 16.9991C6.74056 16.9988 6.19925 16.4642 6.19925 15.6682C6.1985 13.0225 6.19925 10.3764 6.19925 7.73076V7.54505L6.19888 7.54579ZM9.20118 11.9788C9.20118 11.3053 9.20193 10.6316 9.20118 9.95813C9.20081 9.58303 8.94627 9.31093 8.59952 9.31277C8.25877 9.31462 8.00048 9.5834 7.99974 9.94817C7.99786 11.2998 7.99786 12.6514 8.00161 14.0031C8.00161 14.1017 8.0241 14.2072 8.06459 14.297C8.17705 14.5469 8.4567 14.6761 8.72885 14.6204C8.99875 14.565 9.19856 14.3254 9.20006 14.0407C9.20306 13.3533 9.20118 12.6658 9.20118 11.9788ZM12.801 11.9729C12.801 12.6463 12.8003 13.3201 12.801 13.9935C12.8014 14.3638 13.0473 14.627 13.3929 14.6307C13.7464 14.6344 14.0021 14.3726 14.0025 13.9953C14.0043 12.6481 14.004 11.3013 14.0017 9.95407C14.0017 9.87248 13.9894 9.78719 13.9631 9.71003C13.8705 9.43867 13.5905 9.27622 13.3112 9.32274C13.0106 9.37258 12.8033 9.60666 12.8018 9.91051C12.7988 10.598 12.801 11.2854 12.8006 11.9725L12.801 11.9729ZM11.597 11.9788H11.5985C11.5985 11.3146 11.5992 10.6504 11.5973 9.98619C11.5973 9.90386 11.5947 9.81858 11.5726 9.73994C11.495 9.46488 11.218 9.28324 10.9428 9.31684C10.6373 9.35412 10.4116 9.58118 10.4064 9.87876C10.3985 10.3078 10.403 10.7368 10.403 11.1658C10.403 12.0976 10.4023 13.0295 10.4038 13.961C10.4038 14.0433 10.4056 14.129 10.4277 14.2072C10.5087 14.4926 10.7809 14.6617 11.0864 14.6259C11.3645 14.5934 11.5921 14.3557 11.5947 14.0684C11.6011 13.3721 11.5966 12.6754 11.5966 11.9788H11.597Z" fill="white" />
      <path d="M6.19888 7.54579C5.67406 7.50591 5.30107 7.27443 5.09902 6.8181C4.76014 6.05164 5.33256 5.18698 6.18538 5.17922C7.17915 5.17036 8.17255 5.17479 9.16632 5.17922C9.27128 5.17959 9.31702 5.15006 9.36162 5.05591C9.68588 4.37178 10.2403 4 11.002 4C11.7581 4 12.3081 4.36883 12.638 5.04446C12.6582 5.08581 12.6762 5.12827 12.6983 5.17664C12.9094 5.17664 13.1197 5.17664 13.3303 5.17664C14.1599 5.17664 14.9895 5.17331 15.8191 5.17848C16.3176 5.18181 16.7574 5.49636 16.9279 5.95565C17.0981 6.41308 16.9605 6.92886 16.5823 7.25264C16.3881 7.41878 16.2071 7.4893 15.803 7.54985C15.803 7.60375 15.803 7.66172 15.803 7.71968C15.803 10.3702 15.8033 13.0206 15.803 15.6708C15.803 16.284 15.4723 16.7643 14.9216 16.9316C14.7721 16.977 14.609 16.9965 14.4519 16.9969C12.1506 17.001 9.84933 17.0002 7.54765 16.9991C6.74056 16.9988 6.19925 16.4642 6.19925 15.6682C6.1985 13.0225 6.19925 10.3764 6.19925 7.73076V7.54505L6.19888 7.54579ZM9.20118 11.9788C9.20118 11.3053 9.20193 10.6316 9.20118 9.95813C9.20081 9.58303 8.94627 9.31093 8.59952 9.31277C8.25877 9.31462 8.00048 9.5834 7.99974 9.94817C7.99786 11.2998 7.99786 12.6514 8.00161 14.0031C8.00161 14.1017 8.0241 14.2072 8.06459 14.297C8.17705 14.5469 8.4567 14.6761 8.72885 14.6204C8.99875 14.565 9.19856 14.3254 9.20006 14.0407C9.20306 13.3533 9.20118 12.6658 9.20118 11.9788ZM12.801 11.9729C12.801 12.6463 12.8003 13.3201 12.801 13.9935C12.8014 14.3638 13.0473 14.627 13.3929 14.6307C13.7464 14.6344 14.0021 14.3726 14.0025 13.9953C14.0043 12.6481 14.004 11.3013 14.0017 9.95407C14.0017 9.87248 13.9894 9.78719 13.9631 9.71003C13.8705 9.43867 13.5905 9.27622 13.3112 9.32274C13.0106 9.37258 12.8033 9.60666 12.8018 9.91051C12.7988 10.598 12.801 11.2854 12.8006 11.9725L12.801 11.9729ZM11.597 11.9788H11.5985C11.5985 11.3146 11.5992 10.6504 11.5973 9.98619C11.5973 9.90386 11.5947 9.81858 11.5726 9.73994C11.495 9.46488 11.218 9.28324 10.9428 9.31684C10.6373 9.35412 10.4116 9.58118 10.4064 9.87876C10.3985 10.3078 10.403 10.7368 10.403 11.1658C10.403 12.0976 10.4023 13.0295 10.4038 13.961C10.4038 14.0433 10.4056 14.129 10.4277 14.2072C10.5087 14.4926 10.7809 14.6617 11.0864 14.6259C11.3645 14.5934 11.5921 14.3557 11.5947 14.0684C11.6011 13.3721 11.5966 12.6754 11.5966 11.9788H11.597Z" fill="white" />
    </g>
    <defs>
      <clipPath id="clip0_61_903">
        <rect width="22" height="22" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const leftPrev = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
    <path d="M0.000212678 10.9955C0.00403172 4.92418 4.94561 -0.00909573 11.0128 6.96113e-05C17.0831 0.00923495 22.0147 4.95549 22.0002 11.0199C21.9857 17.0928 17.0395 22.0184 10.9739 22.0001C4.90972 21.9817 -0.00360636 17.0546 0.000212678 10.9955ZM10.298 11.0008C10.3713 10.9222 10.4324 10.8519 10.4981 10.7862C11.3274 9.95598 12.1606 9.1288 12.9846 8.29322C13.1228 8.15345 13.2518 7.98848 13.3313 7.81051C13.5649 7.28809 13.371 6.66866 12.8967 6.34176C12.4072 6.00417 11.7765 6.05916 11.3282 6.50368C10.1224 7.69977 8.92041 8.90043 7.72454 10.1064C7.18616 10.6495 7.19609 11.3629 7.7421 11.912C8.92652 13.1028 10.1148 14.2897 11.3045 15.4751C11.8505 16.0189 12.589 16.0479 13.0907 15.5537C13.6046 15.0474 13.5825 14.3034 13.0304 13.7482C12.1888 12.9027 11.3442 12.061 10.5004 11.217C10.4347 11.1505 10.3721 11.081 10.2973 11.0008L10.298 11.0008Z" fill="#989FA4" />
  </svg>
);

const rightPrev = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
    <path d="M22 11.0045C21.9962 17.0758 17.0546 22.0091 10.9874 21.9999C4.91718 21.9908 -0.0144774 17.0445 3.19339e-05 10.9801C0.0145413 4.90723 4.9607 -0.0184019 11.0264 -7.10722e-05C17.0905 0.0182597 22.0039 4.94542 22 11.0045ZM11.7022 10.9992C11.6289 11.0778 11.5678 11.1481 11.5021 11.2138C10.6728 12.044 9.83967 12.8712 9.01569 13.7068C8.87747 13.8465 8.74841 14.0115 8.66899 14.1895C8.43531 14.7119 8.62928 15.3313 9.10351 15.6582C9.59301 15.9958 10.2238 15.9408 10.672 15.4963C11.8778 14.3002 13.0798 13.0996 14.2757 11.8936C14.8141 11.3505 14.8042 10.6371 14.2581 10.088C13.0737 8.89723 11.8855 7.71032 10.6957 6.52493C10.1497 5.98111 9.41126 5.95209 8.90954 6.44626C8.3956 6.95264 8.41775 7.69657 8.96987 8.25184C9.81141 9.09735 10.656 9.93903 11.4998 10.783C11.5655 10.8495 11.6281 10.919 11.703 10.9992H11.7022Z" fill="#989FA4" />
  </svg>
);

const Slider = ({
  credential, license, setLicenses, credentialType,
}) => {
  const dispatch = useDispatch();

  const [files, setFiles] = useState(credential?.files || []);
  const [thumbnail, setThumbnail] = useState(credential?.files?.[0] || {});
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    setFiles(credential.files);
  }, [credential.files]);

  const resetThumbnail = () => {
    if (credential?.files?.length > 0) {
      setCurrentIndex(0);
      setThumbnail(credential?.files[0]);
    }
  };

  return (
    <div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >

        <div style={{
          position: 'relative',
          width: 336,
          height: 224,
          backgroundColor: '#D9D9D9E5',
          borderRadius: 5,
          overflow: 'hidden',
        }}
        >

          <ImageZoom
            image={{
              src: thumbnail?.s3_url,
              alt: 'license_image',
              className: 'img',
              style: {
                objectFit: 'contain',
                width: '100%',
                height: 'auto',
              },
            }}
            zoomImage={{
              src: thumbnail?.s3_url,
              alt: 'license_image',
              style: {
                height: 'auto',
                maxWidth: 500,
                width: 'auto',
              },
            }}
          />

          <span
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              if (currentIndex - 1 < files.length - 1 && currentIndex - 1 >= 0) {
                const nextIndex = currentIndex - 1;
                setCurrentIndex(nextIndex);
                setThumbnail(files[nextIndex]);
              } else {
                setCurrentIndex(files.length - 1);
                setThumbnail(files[files.length - 1]);
              }
            }}
            style={{
              position: 'absolute',
              top: '40%',
              left: -7,
              cursor: 'pointer',

            }}
          >
            {leftPrev()}
          </span>

          <span
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              if (currentIndex + 1 < files.length) {
                const nextIndex = currentIndex + 1;
                setCurrentIndex(nextIndex);
                setThumbnail(files[nextIndex]);
              } else {
                setCurrentIndex(0);
                setThumbnail(files[0]);
              }
            }}
            style={{
              position: 'absolute',
              top: '40%',
              right: -7,
              cursor: 'pointer',

            }}
          >
            {rightPrev()}
          </span>

          <label
            style={{
              position: 'absolute',
              bottom: -11,
              left: '40%',
              cursor: 'pointer',

            }}
            htmlFor={`file_${credentialType}_${license.id}`}
          >
            {PlusIcon()}

          </label>

          <input
            onChange={async (event) => {
              event.stopPropagation();
              event.preventDefault();

              let file = event.target.files[0];
              const options = {
                maxSizeMB: 1,
              };
              try {
                file = await imageCompression(file, options);
              } catch (error) {
                console.log(error);
              }

              dispatch(uploadCredential(
                file,
                null,
                license.id,
                  credential?.id,
              ))
                .then((res) => {
                  if (!res || res?.error) return;
                  setLicenses((prevState) => {
                    const licenseIndex = prevState.findIndex((data) => data.id === license.id);
                    const cIndex = prevState[licenseIndex].credentials.findIndex((c) => c && c.credential_type === credentialType);

                    prevState[licenseIndex].credentials[cIndex] = res;
                    return [...prevState];
                  });
                });
            }}
            type="file"
            id={`file_${credentialType}_${license.id}`}
            style={{ display: 'none' }}
          />

          <span
            onClick={() => {
              if (thumbnail?._id) {
                dispatch(deleteCredentialFile(license.id, credential.id, thumbnail?.file_id)).then(() => {
                  setLicenses((prevState) => {
                    const licenseIndex = prevState.findIndex((data) => data.id === license.id);
                    const credentialIndex = prevState[licenseIndex].credentials.findIndex((c) => c && c.credential_type === credentialType);

                    if (credentialIndex > -1) {
                      prevState[licenseIndex].credentials[credentialIndex].files = prevState[licenseIndex].credentials[credentialIndex].files.filter((f) => f._id !== thumbnail?._id);
                    }
                    return [...prevState];
                  });
                  resetThumbnail();
                });
              }
            }}
            style={{
              position: 'absolute',
              bottom: -5,
              left: '54%',
              cursor: 'pointer',
            }}
          >
            {DeleteIcon()}
          </span>

        </div>

        <div style={{
          marginTop: 10,
          height: 90,
          display: 'flex',
          flexWrap: 'nowrap',
          overflowX: 'auto',
          margin: 20,
          width: 270,

        }}
        >
          {files.map((file, index) => (
            <div
              onClick={() => {
                setThumbnail(file);
                setCurrentIndex(index);
              }}
              style={{
                width: 92,
                height: 62,
                backgroundColor: '#D9D9D9E5',
                borderRadius: 5,
                position: 'relative',
                flex: '0 0 auto',
                width: 92,
                height: 62,
                maxWidth: '100%',
                marginRight: '10px',
                backgroundImage: `url(${file?.s3_url})`,
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                border: `1px solid ${index === currentIndex ? 'grey' : 'white'}`,

              }}
            >
              <span
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  if (file?._id) {
                    dispatch(deleteCredentialFile(license.id, credential.id, file?.file_id)).then(() => {
                      setLicenses((prevState) => {
                        const licenseIndex = prevState.findIndex((data) => data.id === license.id);
                        const credentialIndex = prevState[licenseIndex].credentials.findIndex((c) => c && c.credential_type === credentialType);

                        if (credentialIndex > -1) {
                          prevState[licenseIndex].credentials[credentialIndex].files = prevState[licenseIndex].credentials[credentialIndex].files.filter((f) => f._id !== file?._id);
                        }
                        return [...prevState];
                      });
                      if (thumbnail._id === file._id) {
                        resetThumbnail();
                      }
                    });
                  }
                }}
                style={{
                  position: 'absolute',
                  bottom: -7,
                  left: '40%',
                  cursor: 'pointer',
                }}
              >
                {DeleteIcon()}
              </span>
            </div>
          ))}

        </div>

      </div>
    </div>
  );
};

export default Slider;
